import React, { useState, useEffect } from "react";
import { NavLinks } from "../nav";
import { Navbar, NavItem, Nav, NavbarToggler, Collapse, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { includes } from "lodash";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Trans } from "react-i18next";
import { LanguageSwitcher } from "components";
import { useClient, useUserContext } from "../hooks";
import { useRecoilState } from "recoil";
import { modalState } from "../atoms";

export const Header = () => {
  const location = useLocation();
  const history = useHistory();
  const [collapsed, setCollapsed] = useState(true);
  const { user, query } = useUserContext();
  const client = useClient();
  const [modal, setModal] = useRecoilState(modalState);
  const toggle = () => setModal(!modal);
  const [languageOptions, setLanguageOptions] = useState([])

  useEffect(() => {
    client.get('core/hesaab_language').then((res) => {
      const allLanguages = res?.data || []
      setLanguageOptions(allLanguages.map(item => ({ value: item.id, code: item.code, label: item.name })))
    })
  }, [])

  return (

    <Navbar className="navbar-1 navbar navbar-default navbar-expand-lg navbar-light  pullLeft">
      <Link
        className="navbar-brand"
        to="/"
        style={{ display: "flex", alignItems: "center" }}
      >
        <img
          src="/images/logo.svg"
          alt="Logo"
          style={{ maxHeight: "auto", width: "100px" }}
        />
      </Link>
      {/* marginRight:'25px' logo right MR*/}
      <NavbarToggler onClick={() => setCollapsed((v) => !v)} />

      <Collapse className="navbar-toggleable-md" isOpen={!collapsed} navbar>
        <NavLinks history={history} />
        {includes(["/login", "/register", "/"], history.location.pathname) ? (
          <Nav navbar>
            <NavItem>
              <a href="#about-us" className="nav-link">
                <Trans>About Us</Trans>
              </a>
            </NavItem>
            <NavItem>
              <a href="#features" className="nav-link">
                <Trans>Features</Trans>
              </a>
            </NavItem>
            <NavItem>
              <a href="#integrated how market-place" className="nav-link">
                <Trans>Market Place</Trans>
              </a>
            </NavItem>
            <NavItem>
              <a href="#pricing" className="nav-link">
                <Trans>Pricing</Trans>
              </a>
            </NavItem>
            <NavItem>
              <a href="#how" className="nav-link">
                <Trans>How it Works</Trans>
              </a>
            </NavItem>
            <NavItem>
              <UncontrolledDropdown>
                <DropdownToggle caret className="nav-link btn-link" color="link">
                  <span><Trans>Help center</Trans></span>
                  <i className="fa fa-angle-down" aria-hidden="true" style={{ color: '#72B566', padding: '4px 3px 0px 3px' }}></i>
                </DropdownToggle>
                <DropdownMenu dark className="p-0">
                  <DropdownItem className="pl-1 py-0">
                    <Link to="/faq" className="nav-link">
                      <Trans>FAQ</Trans>
                    </Link>
                  </DropdownItem>
                  <DropdownItem className="pl-1 py-0">
                    <Link to="/connect-xero" className="nav-link">
                      <Trans>Steps to connect xero</Trans>
                    </Link>
                  </DropdownItem>
                  <DropdownItem className="pl-1 py-0">
                    <a href="/api/download_template?file_name=_دليل استخدام Hesaab الاصدار.pdf" className="nav-link">
                      <Trans>User Guide</Trans>
                    </a>
                  </DropdownItem>
                  <DropdownItem className="pl-1 py-0">
                    <a href="/support" className="nav-link">
                      <Trans>Contact Us</Trans>
                    </a>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </NavItem>
          </Nav>
        ) : null}
        <Nav navbar className="cta-rg">
          <LanguageSwitcher
            languageOptions={languageOptions}
          />

          {user ? (
            <>
              <NavItem>
                <Link to="/profile" className="nav-link">
                </Link>
              </NavItem>
              <NavItem>
                <Link
                  to="/logout"
                  onClick={async (e) => {
                    e.preventDefault();
                    await client.post("logout");
                    localStorage.clear();
                    await query.refetch();
                  }}
                  className="nav-link"
                ><i className="fa fa-sign-out" aria-hidden="true"></i>

                  <Trans>Logout</Trans>
                </Link>
              </NavItem>
            </>
          ) : (
            <>
              <NavItem className="cta-log my-1 w-auto" >
                <Link to="/register" className="nav-link active py-2" onClick={toggle}>
                  <Trans>Register</Trans>
                </Link>
              </NavItem>
              <NavItem className="cta-log mx-2 my-1 w-auto" >
                <Link to="/login" className="nav-link active py-2" onClick={toggle}>
                  <Trans>Sign in</Trans>
                </Link>
              </NavItem>
            </>
          )}

        </Nav>

      </Collapse>


    </Navbar>

  );
};

